// Clean up old service worker and caches on first load of new app
export async function cleanupOldPWA() {
	if (!sessionStorage.getItem("seedgreen-old-app-cleaned")) {
		// Destroy old service worker (with feature detection)
		if ("serviceWorker" in navigator) {
			try {
				const registrations =
					await navigator.serviceWorker.getRegistrations();
				registrations.forEach((registration) => {
					if (
						registration.active?.scriptURL.includes(
							"service-worker.js",
						)
					) {
						console.info("Unregistering old service worker");
						registration.unregister();
					}
				});
			} catch (error) {
				console.error("Service worker cleanup failed:", error);
			}
		}

		// Delete old app caches (with feature detection)
		if ("caches" in window) {
			try {
				const cacheNames = await caches.keys();
				for (const cacheName of cacheNames) {
					if (cacheName.includes("seedgreen-mobile")) {
						await caches.delete(cacheName);
					}
				}
			} catch (error) {
				console.error("Cache cleanup failed:", error);
			}
		}

		sessionStorage.setItem("seedgreen-old-app-cleaned", "true");
	}
}
